export default __webpack_public_path__ + "static/media/circle.a85b0e63.svg";